import View from './view';
import {target} from '../utils/dom';

const defaults = {
	el: null
};

class PersonalisationForm extends View {
	constructor(options) {
		super(options, defaults);
	}

	initEvents() {
		super.initEvents();
		//this.el.addEventListener('click', this.onClick.bind(this));
	}

	onClick(event) {
	}
}

export default PersonalisationForm;
